import { useEffect } from 'react';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { gsap } from "gsap";


const DownloadRoot = styled(Button)(
  ({ theme }) => `
    white-space: nowrap;
    i {
      display: flex;
      overflow: hidden;
      position: relative;
    }
    &:hover{
      svg {
      }
    }
    

.button {
  --text: #fff;
  --check: #fff;
  --background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 0;
  outline: none;
  color: var(--text);
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(#414856, 0.05);
  transition: transform .1s linear;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  .icons {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0px 0 0 15px;
    .arrow {
      height: 14px;
      width: 16px;
      stroke-width: 2px;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke: var(--text);
      fill: none;
      transform: rotate(var(--r, 0deg)) translateY(var(--y, 0px));
      transform-origin: var(--transOrigin, bottom right);
    }
    .line {
      margin-top: 2px;
      height: 4px;
      width: 18px;
      stroke-width: 2px;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke: var(--text);
      fill: none;
      stroke-dashoffset: var(--sd, 0);
      stroke-dasharray: 16 32;
      --sd: 0;
      transform: rotate(var(--r, 0deg)) translate(var(--x, 0px), var(--y, 0px)) ;
    }
    .check {
      position: absolute;
      height: 13px;
      width: 17px;
      stroke-width: 2px;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke: var(--check);
      fill: none;
      stroke-dashoffset: var(--sd, 32);
      stroke-dasharray: 18 36;
      --sd: 32;
      transform: translateY(-2px);
    }
  }
  > .text {
    display: block;
    position: relative;
    overflow: hidden;
    letter-spacing: .7px;
    > span {
      display: block;
      transition: transform .3s ease, opacity .3s ease;
      &::before{
        content: attr(data-text);
        display: block;
        position: absolute;
        left: 0;
        bottom: 100%;
      }
    }
  }
  &:active {
      transform: scale(.97);
  }
  &.active {
    > .text {
      > span {
        transform: translateY(100%);
        transition: transform .3s ease 1.9s, opacity .3s ease 1.9s;
      }
    }
  }
}
  `
);


export default function ButtonDownload({ primary, children, maxWidth= 348, onClick, progress, ...other }) {


  useEffect(() => {
    document.querySelectorAll('.button').forEach(element => {
      // eslint-disable-next-line prefer-const
      const arrow = element.querySelector('.arrow');
      // eslint-disable-next-line prefer-const
      const line = element.querySelector('.line');
      // eslint-disable-next-line prefer-const
      const linePath = element.querySelector('.line path');
      const check = element.querySelector('.check');

      element.addEventListener('click', e => {
        e.preventDefault()
        if(!element.classList.contains('active')) {
          element.classList.add('active');
          gsap.to(arrow, {
            keyframes: [ {
              '--r': '30deg',
              '--y': '-8px',
              duration: .4,
              ease: 'power2.out'
            }, {
              '--r': '0deg',
              '--y': '6px',
              duration: .2,
              ease: 'power2.out',
              onStart() {
                gsap.to(linePath, {
                  keyframes: [ {
                    morphSVG: 'M1 3s4.415 2.5 8 2.5S17 3 17 3',
                    duration: .2
                  }, {
                    morphSVG: 'M1 3h16',
                    duration: .5,
                    ease: 'elastic.out(1, .5)'
                  }]
                })
              }
            }, {
              '--r': '0deg',
              '--y': '0px',
              duration: .7,
              ease: 'elastic.out(1, .5)',
              onComplete() {
                gsap.to(arrow, {
                  scale: 0,
                  y: 5,
                  '--transOrigin': 'bottom center',
                  duration: .2,
                  ease: 'power2.in'
                })
                gsap.to(line, {
                  '--sd': 15.9,
                  '--y': '1px',
                  '--x': '-3px',
                  '--r': '45deg',
                  '--text': 'var(--check)',
                  duration: .5,
                  ease: 'power3.out',
                  onComplete() {
                    gsap.to(check, {
                      keyframes: [{
                        '--sd': 54,
                        duration: .25,
                        onStart() {
                          gsap.to(line, {
                            opacity: 0,
                            duration: .1
                          })
                        }
                      }, {
                        '--sd': 51,
                        duration: 1,
                        ease: 'elastic.out(1, .5)'
                      }],
                      onComplete:allDone
                    })
                  }
                })
              }
            }]
          })
          // eslint-disable-next-line no-inner-declarations
          function allDone(){
            setTimeout(() => {
              gsap.to(check, {
                opacity: 0,
                scale: 0,
                duration: .3,
                ease: 'power2.out',
                clearProps: true
              })
              gsap.to(arrow, {
                delay: .2,
                opacity: 1,
                scale: 1,
                '--transOrigin': 'center',
                duration: .3,
                y: 0,
                clearProps: true
              })
              gsap.to(line, {
                keyframes: [{
                  delay: .2,
                  '--y': '0px',
                  '--x': '0px',
                  '--r': '0deg',
                  '--text': '#fff',
                  duration: 0,
                  opacity: 1
                },{
                  '--sd': 0,
                  duration: .3,
                  ease: 'power2.out',
                  clearProps: true
                }]
              })
              element.classList.remove('active');
            }, 2000);
          }
        }
      })
    });

  }, []);

  return (
    <DownloadRoot
      onClick={onClick}
      display={'inline-flex'}
      alignItems={'center'}
      gap={1}
      maxWidth={maxWidth}
      fontSize={18}
      fontWeight={700}
      color={'#EE3A43'}
      textAlign={'left'}
      p={1}
      size={'medium'}
      { ...other }
    >
      <Typography variant={'contained'} color={'error'} className="button">
        <div className="text">
          <Typography component={'span'} fontSize={18} fontWeight={700} lineHeight={'normal'} data-text="下載成功">
            {primary}
          </Typography>
        </div>
        <div className="icons">
          <svg className="arrow">
            <use xlinkHref="#arrow" />
          </svg>
          <svg className="line">
            <path d="M1 3h16" />
          </svg>
          <svg className="check">
            <path d="M16 1L5 12 1 8" />
          </svg>
        </div>
      </Typography>


      <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
        <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" id="arrow">
          <path d="M7 1v14" />
          <path d="M13 9l-6 6-6-6" />
        </symbol>
      </svg>
    </DownloadRoot>
  )
}
